import React from 'react';
import classNames from 'classnames';
import './CircularSelect.styl';

const DAYS_OF_WEEK = {
  M: 'Monday',
  TU: 'Tuesday',
  W: 'Wednesday',
  TH: 'Thursday',
  F: 'Friday',
  SA: 'Saturday',
  SU: 'Sunday',
};

export default class DaysOfWeekSelector extends React.PureComponent {
  onClickDay(day) {
    const {value: days, onChange} = this.props;
    onChange(days.includes(day) ? days.filter(otherDay => otherDay !== day) : days.push(day));
  }
  render() {
    // TODO: a must be replaced with button and eslint ignore must be removed
    /* eslint jsx-a11y/anchor-is-valid: "off", no-script-url: "off" */
    return (
      <div className="circular-select">
        {Object.keys(DAYS_OF_WEEK).map(label => (
          <a
            href="javascript:;"
            key={label}
            className={classNames({
              selected: this.props.value.includes(DAYS_OF_WEEK[label]),
            })}
            onClick={() => this.onClickDay(DAYS_OF_WEEK[label])}>
            {label}
          </a>
        ))}
      </div>
    );
  }
}
